import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative w-full py-16 md:py-24 px-6 overflow-hidden bg-cream" data-id="element-97">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-98">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col space-y-8 order-2 lg:order-1" data-id="element-99">
          <div className="space-y-4" data-id="element-100">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-semibold leading-[1.1] text-charcoal tracking-tight" data-id="element-101">
              You're Not{' '}
              <span className="italic text-teal" data-id="element-102">"Too Sensitive."</span> <br data-id="element-103" />
              You're Overloaded.
            </h1>
            <p className="text-xl md:text-2xl text-charcoal-muted leading-relaxed font-sans max-w-xl" data-id="element-104">
              A burnout-safe, 7-day nervous system reset for women 30+ who are
              still functioning… but paying for it in anxiety.
            </p>
          </div>

          <div className="pt-4" data-id="element-105">
            <Button onClick={() => document.getElementById('cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-106">
              Start Your Reset
            </Button>
            <p className="mt-4 text-sm text-charcoal-muted italic" data-id="element-107">
              Instant PDF download • 7-day protocol
            </p>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-108">
          <div className="relative w-full max-w-md lg:max-w-full" data-id="element-109">
            <div className="absolute inset-0 bg-amber/10 rounded-3xl blur-3xl transform rotate-3 scale-95" data-id="element-110" />
            <img src="https://cdn.magicpatterns.com/uploads/2RMsKd7V3WWoHwDSJZJpe1/heylloyd-image-1770798720501.png" alt="The 7-Day Minimum Viable Calm Reset Ebook Cover" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform hover:scale-[1.01] transition-transform duration-700" data-id="element-111" />
          </div>
        </motion.div>
      </div>
    </section>;
}